import { ProductImportComponent } from './components/product-import/product-import.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanActivateLogIn } from './helpers/guards/log-in.guard';
import { LoginComponent } from './components/auth/login/login.component';
import { RegistrationComponent } from './components/auth/registration/registration.component';
import { ResendActivationComponent } from './components/auth/resend-activation/resend-activation.component';
import { PasswordRecoveryComponent } from './components/auth/password-recovery/password-recovery.component';
import { UserLoggedIn } from './helpers/guards/logged-in.guard';
import { LogOut } from './helpers/guards/log-out.guard';
import { DeliveriesComponent } from './components/deliveries/deliveries.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { DeliveryFormComponent } from './components/delivery-form/delivery-form.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ExpertsComponent } from './components/experts/experts.component';
import { PartnersComponent } from './components/partners/partners.component';
import { GroupRestricted } from './helpers/guards/group-restricted.guard';
import { UsersComponent } from './components/users/users.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ExpertFormDecoratorComponent } from './components/expert-form-decorator/expert-form-decorator.component';
import { PartnerFormDecoratorComponent } from './components/partner-form-decorator/partner-form-decorator.component';
import { OffersComponent } from './components/offers/offers.component';
import { OfferFormComponent } from './components/offer-form/offer-form.component';
import { ProductsComponent } from './components/products/products.component';
import { ProductFormComponent } from './components/product-form/product-form.component';
import { DeliveryCanActivateLogIn } from './helpers/guards/delivery-log-in.guard';
import { SmsTemplatesComponent } from './components/sms-templates/sms-templates.component';
import { SmsTemplatesFormComponent } from './components/sms-templates-form/sms-templates-form.component';
import { AdminSmsTemplatesComponent } from './components/admin-sms-templates/admin-sms-templates.component';
import { AdminSmsTemplateFormComponent } from './components/admin-sms-templates-form/admin-sms-template-form.component';
import { ShopifySaleComponent } from './components/shopify-sale/shopify-sale.component';
import { ShopifySaleFormComponent } from './components/shopify-sale-form/shopify-sale-form.component';
import { PartnerInvoiceComponent } from './components/partner-invoice/partner-invoice.component';
import { ServiceComponent } from './components/service/service.component';
import { ServiceFormComponent } from './components/service-form/service-form.component';
import { DuplicateDeliveryComponent } from './components/duplicate-delivery/duplicate-delivery.component';
import { DuplicatePartnerComponent } from './components/duplicate-partner/duplicate-partner.component';
import { ExpertServiceComponent } from './components/expert-service/expert-service.component';
import { ExpertServiceFormComponent } from './components/expert-service-form/expert-service-form.component';
import { ExpertSalaryComponent } from './components/expert-salary/expert-salary.component';
import { ProductCategoryFormComponent } from './components/product-category-form/product-category-form.component';
import { ProductCategoryComponent } from './components/product-category/product-category.component';
import { TestComponent } from './components/test/test.component';
import { PartnerAvailabilityComponent } from './components/partner-availability/partner-availability.component';
import { ExpertAvailabilityComponent } from './components/expert-availability/expert-availability.component';
import { PartnerAvailabilityListComponent } from './components/partner-availability-list/partner-availability-list.component';
import { ExpertAvailabilityListComponent } from './components/expert-availability-list/expert-availability-list.component';
import { DuplicateProductComponent } from './components/duplicate-product/duplicate-product.component';
import { PartnerPriorityListComponent } from './components/partner-priority-list/partner-priority-list.component';
import { PartnerPriorityListFormComponent } from './components/partner-priority-list-form/partner-priority-list-form.component';
import { ConfirmSaleComponent } from './components/confirm-sale/confirm-sale.component';
import { PartnerSaleActivityComponent } from './components/partner-sale-activity/partner-sale-activity.component';
import { DuplicatePartnerPriorityListComponent } from './components/duplicate-partner-priority-list/duplicate-partner-priority-list.component';
import { SaleDeliveryDetailComponent } from './components/sale-delivery-detail/sale-delivery-detail.component';
import { CakeOrdersDetailsComponent } from './components/cake-orders-details/cake-orders-details.component';
import { ValetPriorityListComponent } from './components/valet-priority-list/valet-priority-list.component';
import { ValetPriorityListFormComponent } from './components/valet-priority-list-form/valet-priority-list-form.component';
import { DuplicateValetPriorityListComponent } from './components/duplicate-valet-priority-list/duplicate-valet-priority-list.component';
import { OperationComponent } from './components/operation/operation.component';
import { OperationFormDecoratorComponent } from './components/operation-form-decorator/operation-form-decorator.component';
import { TeamLeaderComponent } from './components/team-leader/team-leader.component';
import { TeamLeaderFormDecoratorComponent } from './components/team-leader-form-decorator/team-leader-form-decorator.component';
import { ValetOwnAvailabilityComponent } from './components/valet-own-availability/valet-own-availability.component';
import { CakeSaleComponent } from './components/cake-sale/cake-sale.component';
import { BusinessSaleComponent } from './components/business-sale/business-sale.component';
import { DeluxyFlowersSaleComponent } from './components/deluxy-flowers-sale/deluxy-flowers-sale.component';
import { CakeSaleFormComponent } from './components/cake-sale-form/cake-sale-form.component';
import { BusinessSaleFormComponent } from './components/business-sale-form/business-sale-form.component';
import { DeluxyFlowersSaleFormComponent } from './components/deluxy-flowers-sale-form/deluxy-flowers-sale-form.component';
import { AllSalesComponent } from './components/all-sales/all-sales.component';
import { PartnerDeliveryRulesComponent } from './components/partner-delivery-rules/partner-delivery-rules.component';
import { PartnerDeliveryRulesFormComponent } from './components/partner-delivery-rules-form/partner-delivery-rules-form.component';
import { ExpertDeliveryRulesComponent } from './components/expert-delivery-rules/expert-delivery-rules.component';
import { ExpertDeliveryRulesFormComponent } from './components/expert-delivery-rules-form/expert-delivery-rules-form.component';
import { ProductPriorityListFormComponent } from './components/product-priority-list-form/product-priority-list-form.component';
import { ProductPriorityListComponent } from './components/product-priority-list/product-priority-list.component';
import { ValetActivitiesComponent } from './components/valet-activities/valet-activities.component';
import { AdminValetActivityComponent } from './components/admin-valet-activity/admin-valet-activity.component';
import { ApproveTimingsAdminComponent } from './components/approve-timings-admin/approve-timings-admin.component';
import { ActvitiesComponent } from './components/actvities/actvities.component';
import { ActivityRedirection } from './helpers/guards/activity-redirection.guard';
import { ShowMapDirectionComponent } from './components/show-map-direction/show-map-direction.component';
import { CustomersComponent } from './components/customers/customers.component';
import { CustomerFormDecoratorComponent } from './components/customer-form-decorator/customer-form-decorator.component';
import { ProvinceCitiesComponent } from './components/province-cities/province-cities.component';
import { ProvinceCitiesFormComponent } from './components/province-cities-form/province-cities-form.component';
import { ValetPaymentsComponent } from './components/valet-payments/valet-payments.component';
import { ValetPaymentReceiptsComponent } from './components/valet-payment-receipts/valet-payment-receipts.component';
import { FinanceComponent } from './components/finance/finance.component';
import { FinanceMarginComponent } from './components/finance-margin/finance-margin.component';
import { FinanceFeesComponent } from './components/finance-fees/finance-fees.component';
import { SuperAdminGuard } from './helpers/guards/super-admin.guard';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { TransactionsTabsComponent } from './components/transactions-tabs/transactions-tabs.component';
import { QontoCallbackComponent } from './components/qonto-callback/qonto-callback.component';
import { ShopCollectionComponent } from './components/shop-collection/shop-collection.component';
import { ShopCollectionFormComponent } from './components/shop-collection-form/shop-collection-form.component';
import { CustomSalesFormComponent } from './components/custom-sales-form/custom-sales-form.component';
import { CustomSalePaymentComponent } from './components/custom-sale-payment/custom-sale-payment.component';
import { CustomSalePaymentSuccessComponent } from './components/custom-sale-payment-success/custom-sale-payment-success.component';
import { CustomSalePaymentCancelComponent } from './components/custom-sale-payment-cancel/custom-sale-payment-cancel.component';
import { CustomSalesPaymentsComponent } from './components/custom-sales-payments/custom-sales-payments.component';
import { CustomSaleDeliveryDetailsComponent } from './components/custom-sale-delivery-details/custom-sale-delivery-details.component';
import { ParentProductsComponent } from './components/parent-products/parent-products.component';
import { PartnerStripeCardComponent } from './components/partner-stripe-card/partner-stripe-card.component';
import { PartnerStripeCardFormComponent } from './components/partner-stripe-card-form/partner-stripe-card-form.component';
import { CustomerCardInfoComponent } from './components/customer-card-info/customer-card-info.component';
import { DeliveryMonitoringComponent } from './components/delivery-monitoring/delivery-monitoring.component';
import { SaleTrackingComponent } from './components/sale-tracking/sale-tracking.component';
import { ParentDeliveriesComponent } from './components/parent-deliveries/parent-deliveries.component';
import { ViewRestricted } from './helpers/guards/view-restricted.guard';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { DeliveredDeliveryComponent } from './components/delivered-delivery/delivered-delivery.component';
import { ValetContractsComponent } from './components/valet-contracts/valet-contracts.component';
import { DeluxyDotComSaleComponent } from './components/deluxy-dot-com-sale/deluxy-dot-com-sale.component';
import { DeluxyDotComSaleFormComponent } from './components/deluxy-dot-com-sale-form/deluxy-dot-com-sale-form.component';
import { DeluxyExperienceSaleComponent } from './components/deluxy-experience-sale/deluxy-experience-sale.component';
import { DeluxyExperienceSaleFormComponent } from './components/deluxy-experience-sale-form/deluxy-experience-sale-form.component';
import { AvailabilityListComponent } from './components/availability-list/availability-list.component';
import { BundleProductComponent } from './components/bundle-product/bundle-product.component';
import { BundleProductFormComponent } from './components/bundle-product-form/bundle-product-form.component';
import { PartnerActivityReminderSettingsComponent } from './components/partner-activity-reminder-settings/partner-activity-reminder-settings.component';


const routes: Routes = [
  // { path: '', redirectTo: 'consegne', pathMatch: 'full' },
  { path: '', redirectTo: 'nuovo-consegne', pathMatch: 'full' },

  { path: 'push/login', component: LoginComponent, canActivate: [UserLoggedIn], data: { blank: true } },
  { path: 'logout', component: LoginComponent, canActivate: [LogOut], data: { blank: true } },
  { path: 'register', component: RegistrationComponent, canActivate: [UserLoggedIn], data: { blank: true } },
  { path: 'verify/:token', component: RegistrationComponent, canActivate: [UserLoggedIn], data: { blank: true } },
  { path: 'resend_activation', component: ResendActivationComponent, canActivate: [UserLoggedIn], data: { blank: true } },
  { path: 'reset_password', redirectTo: 'reset_password/', pathMatch: 'full', data: { blank: true } },
  { path: 'reset_password/:token', component: PasswordRecoveryComponent, canActivate: [UserLoggedIn], data: { blank: true } },
  { path: 'activate/:token', component: PasswordRecoveryComponent, canActivate: [UserLoggedIn], data: { blank: true, activate: true } },

  // { path: 'consegne', component: DeliveriesComponent, canActivate: [CanActivateLogIn], data: { active: true } },
  // { path: 'consegne/storico', component: DeliveriesComponent, canActivate: [CanActivateLogIn], data: { active: false } },
  { path: 'consegne/nuovo', component: DeliveryFormComponent, canActivate: [CanActivateLogIn, GroupRestricted, ViewRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  { path: 'consegne/:id', component: DeliveryComponent, canActivate: [DeliveryCanActivateLogIn, ViewRestricted] },
  { path: 'consegne/:id/edit', component: DeliveryFormComponent, canActivate: [CanActivateLogIn, GroupRestricted, ViewRestricted], data: { groups: ['admin', 'operation', 'partner'] } },

  {
    path: 'nuovo-consegne',
    component: ParentDeliveriesComponent,
    canActivate: [CanActivateLogIn, ViewRestricted],
    data: { groups: ['admin', 'operation', 'partner'] },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'attiva', // Redirect base path to attiva
        data: { 
          groups: ['admin', 'operation', 'partner']
        },
      },
      {
        path: 'archivio',
        component: DeliveriesComponent,
        data: { 
          titleKey: 'attivaStorico',
          title: 'NON CONSEGNATE CONSEGNE',
          groups: ['admin', 'operation', 'partner'],
          active: true,
          notdelivered: true, 
        },
      },
      {
        path: 'attiva',
        children: [
          {
            path: '',
            component: DeliveriesComponent,
            data: {
              titleKey: 'active',
              title: 'ATTIVE CONSEGNE',
              groups: ['admin', 'operation', 'partner'], 
              active: true,
              notdelivered: false,  
            },
          },
        ],
      },
      {
        path: 'attiva/storico',
        component: DeliveriesComponent,
        data: { 
          titleKey: 'inactive',
          title: 'STORICO CONSEGNE ATTIVE',
          groups: ['admin', 'operation', 'partner'], 
          active: false,
          notdelivered: false,  
        },
      },

      {
        path: 'archivio/storico',
        component: DeliveriesComponent,
        data: { 
          titleKey: 'inactiveStorico', 
          title: 'STORICO NON CONSEGNATE CONSEGNE',
          groups: ['admin', 'operation', 'partner'], 
          active: false,
          notdelivered: true, 
        },
      },
    ],
  },

  { path: 'offerte', component: OffersComponent, canActivate: [CanActivateLogIn], data: { active: true, groups: ['admin', 'operation', 'partner'] } },
  { path: 'offerte/nuovo', component: OfferFormComponent, canActivate: [CanActivateLogIn], data: { active: true, groups: ['admin', 'operation', 'partner'] } },
  { path: 'offerte/:id', component: OfferFormComponent, canActivate: [CanActivateLogIn], data: { active: true, groups: ['admin', 'operation', 'partner'] } },

  { path: 'expert', component: ExpertsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader', 'expert'] } },
  { path: 'expert/nuovo/:userId', component: ExpertFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation',] } },
  { path: 'expert/nuovo', component: ExpertFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader'] } },
  { path: 'expert/:id/edit', component: ExpertFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  /*
  { path: 'expert/:id/availability', component: ExpertAvailabilityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'expert', 'operation', 'teamleader'] } },
  { path: 'expert/availability/list', component: ExpertAvailabilityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader', 'expert'] } },
  */
  { path: 'expert/rules', component: ExpertDeliveryRulesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'expert/rules/nuovo', component: ExpertDeliveryRulesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'expert/rules/edit/:id', component: ExpertDeliveryRulesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },

  { path: 'partner', component: PartnersComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader', 'expert'] } },
  { path: 'partner/nuovo/:userId', component: PartnerFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'partner/nuovo', component: PartnerFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader'] } },
  { path: 'partner/:id/edit', component: PartnerFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  /*
  { path: 'partner/:id/availability', component: PartnerAvailabilityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation', 'expert'] } },
  { path: 'partner/availability/list', component: PartnerAvailabilityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'teamleader', 'expert'] } },
  */
  { path: 'partner/priority/list', component: PartnerPriorityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/priority/list/nuovo', component: PartnerPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/priority/list/:id/edit', component: PartnerPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/vendita', component: PartnerSaleActivityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: {active: true, groups: ['partner'] } },
  { path: 'partner/vendita/storico', component: PartnerSaleActivityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: {active: false, groups: ['partner'] } },
  { path: 'partner/delivery/rules', component: PartnerDeliveryRulesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/delivery/rules/nuovo', component: PartnerDeliveryRulesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/delivery/rules/edit/:id', component: PartnerDeliveryRulesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/invoices', component: InvoicesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] } },

  { path: 'expert/:id/availability', component: ExpertAvailabilityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'expert', 'operation', 'teamleader'], oldView: true } },
  { path: 'partner/:id/availability', component: PartnerAvailabilityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation', 'expert'], oldView: true } },

  {
    path: 'partners/availability',
    component: AvailabilityListComponent,
    data: {
      userType: 'partner',
      title: 'Partner Disponibilità Lista',
      groups: ['admin', 'operation', 'expert']
    },
    canActivate: [CanActivateLogIn, GroupRestricted]
  },

  {
    path: 'experts/availability',
    component: AvailabilityListComponent,
    data: {
      userType: 'expert',
      title: 'Expert Disponibilità Lista',
      groups: ['admin', 'operation', 'expert']
    },
    canActivate: [CanActivateLogIn, GroupRestricted]
  },

  { 
    path: 'partner/availability/:id', 
    component: PartnerAvailabilityComponent, 
    canActivate: [CanActivateLogIn, GroupRestricted], 
    data: { 
      groups: ['admin', 'partner', 'operation', 'expert'] 
    } 
  },

  { 
    path: 'expert/availability/:id', 
    component: ExpertAvailabilityComponent, 
    canActivate: [CanActivateLogIn, GroupRestricted], 
    data: { 
      groups: ['admin', 'operation', 'expert'] 
    } 
  },

  // { path: 'prodotti', component: ProductsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  {
    path: 'prodotti',
    component: ParentProductsComponent,
    canActivate: [CanActivateLogIn, GroupRestricted],
    data: { groups: ['admin', 'operation', 'partner'] },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'attiva', // Redirect base path to attiva
        data: { groups: ['admin', 'operation', 'partner']},
      },
      {
        path: 'archivio',
        component: ProductsComponent,
        data: { 
          groups: ['admin', 'operation', 'partner'],
          active: false,
          view: 'inactive',
        },
      },
      {
        path: 'attiva',
        children: [
          {
            path: '',
            component: ProductsComponent,
            data: { 
              groups: ['admin', 'operation', 'partner'], 
              active: true ,
              view: 'active',
            },
          },
        ],
      },
      {
        path: 'shopify',
        component: ProductsComponent,
        canActivate: [CanActivateLogIn, GroupRestricted],
        data: {
          groups: ['admin', 'operation'],
          active: true,
          view: 'shopify',
          defaultFilters: {
            'Product.productStatus': {
              operator: 'like',
              values: ['%1%'],
            },
            'Product.adminApproval': {
              operator: 'like',
              values: ['%1%'],
            },
          },
          orFilters: [
            {
              field: 'Product.isDeluxyProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isCakeProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isFlowersProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isBusinessProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isDeluxyExperienceProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isDeluxyDotComProduct',
              operator: 'like',
              value: 1,
            },
            {
              field: 'Product.isSuperProvinceProduct',
              operator: 'like',
              value: 1,
            },
          ],
        },
      }
    ],
  },
  { path: 'prodotti/nuovo', component: ProductFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  { path: 'prodotti/:id', component: ProductFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  { path: 'product/categoria', component: ProductCategoryComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/categoria/nuovo', component: ProductCategoryFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/categoria/:id/edit', component: ProductCategoryFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/priority-list', component: ProductPriorityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/priority-list/nuovo', component: ProductPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/priority-list/edit/:id', component: ProductPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },

  { path: 'utenti', component: UsersComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation',] } },
  { path: 'profilo', component: ProfileComponent, canActivate: [CanActivateLogIn] },

  { path: 'smstemplates', component: SmsTemplatesComponent, canActivate: [CanActivateLogIn], data: { groups: ['partner', 'operation',] } },
  { path: 'smstemplates/nuovo', component: SmsTemplatesFormComponent, canActivate: [CanActivateLogIn], data: { groups: ['partner'] } },
  { path: 'smstemplates/:id/edit', component: SmsTemplatesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['partner'] } },

  { path: 'admin/smstemplates', component: AdminSmsTemplatesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation',] } },
  { path: 'admin/smstemplates/nuovo', component: AdminSmsTemplateFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'admin/smstemplates/:id/edit', component: AdminSmsTemplateFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },

  { path: 'vendita', component: ShopifySaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'vendita/storico', component: ShopifySaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'vendita/edit/:id', component: ShopifySaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'vendita/detail/:id', component: SaleDeliveryDetailComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner'] }  },
  { path: 'confirm/sale/:token', component: ConfirmSaleComponent },

  /* For Partner Invoice */
  { path: 'partner/fattura', component: PartnerInvoiceComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'partner'] }  },
  { path: 'partner/fattura/storico', component: PartnerInvoiceComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'partner'] }  },
  /* For Partner Invoice */


  { path: 'servizi', component: ServiceComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  { path: 'servizi/nuovo', component: ServiceFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'servizi/:id/edit', component: ServiceFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },

  // { path: 'under-maintinance', component: UnderMaintinanceComponent },
  { path: 'consegne/duplica/:id', component: DuplicateDeliveryComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'partner', 'operation'] } },
  { path: 'partner/duplica/:id', component: DuplicatePartnerComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product/duplica/:id', component: DuplicateProductComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'partner/priority/list/duplica/:id', component: DuplicatePartnerPriorityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },

  { path: 'valet/servizi', component: ExpertServiceComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'valet/servizi/nuovo', component: ExpertServiceFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'valet/servizi/:id/edit', component: ExpertServiceFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  /* For Partner Invoice */
  { path: 'valet/stipendi', component: ExpertSalaryComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'expert', 'operation'] }  },
  { path: 'valet/stipendi/storico', component: ExpertSalaryComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'expert', 'operation'] }  },
  { path: 'valet/priority-list', component: ValetPriorityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'valet/priority-list/nuovo', component: ValetPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'valet/priority-list/edit/:id', component: ValetPriorityListFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'valet/priority-list/duplica/:id', component: DuplicateValetPriorityListComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  
  // { path: 'valet/activities', component: ValetActivitiesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['expert'], data: { active: true } } },
  // { path: 'valet/activities/storico', component: ValetActivitiesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['expert'], data: { active: false } } },
  // { path: 'admin/valet/activity', component: AdminValetActivityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'expert'], data: { active: true } } },
  // { path: 'admin/valet/activity/storico', component: AdminValetActivityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'expert'], data: { active: false } } },
  /* For Partner Invoice */

  { path: 'cake/orders', component: CakeOrdersDetailsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },

  /* NEW ROLE OPERATION */
  { path: 'operation', component: OperationComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'operation/nuovo/:userId', component: OperationFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'operation/nuovo', component: OperationFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'operation/edit/:id', component: OperationFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  /* NEW ROLE OPERATION */


  /* NEW ROLE TEAM LEADER*/
  { path: 'team/leader', component: TeamLeaderComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'team/leader/nuovo/:userId', component: TeamLeaderFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'team/leader/nuovo', component: TeamLeaderFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  { path: 'team/leader/edit/:id', component: TeamLeaderFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] } },
  /* NEW ROLE TEAM LEADER */

  { path: 'expert/availability/:id', component: ValetOwnAvailabilityComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['expert'] } },

  /* New Sales Integration */
  { path: 'cakes/vendita', component: CakeSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'cakes/vendita/storico', component: CakeSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'cakes/vendita/edit/:id', component: CakeSaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },

  { path: 'business/vendita', component: BusinessSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'business/vendita/storico', component: BusinessSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'business/vendita/edit/:id', component: BusinessSaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },

  { path: 'flowers/vendita', component: DeluxyFlowersSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'flowers/vendita/storico', component: DeluxyFlowersSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'flowers/vendita/edit/:id', component: DeluxyFlowersSaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },

  { path: 'deluxydotcom/vendita', component: DeluxyDotComSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'deluxydotcom/vendita/storico', component: DeluxyDotComSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'deluxydotcom/vendita/edit/:id', component: DeluxyDotComSaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },


  { path: 'experience/vendita', component: DeluxyExperienceSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'experience/vendita/storico', component: DeluxyExperienceSaleComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'experience/vendita/edit/:id', component: DeluxyExperienceSaleFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },

  { path: 'all/vendita', component: AllSalesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] }  },
  { path: 'all/vendita/storico', component: AllSalesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'custom/sales/nuovo', component: CustomSalesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'custom/sales/edit/:platform/:id', component: CustomSalesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },
  { path: 'custom/sale/pament/:token', component: CustomSalePaymentComponent },
  { path: 'payment-success', component: CustomSalePaymentSuccessComponent },
  { path: 'payment-cancel', component: CustomSalePaymentCancelComponent },
  { path: 'order-details', component: CustomSaleDeliveryDetailsComponent, data: { blank: true } },
  { path: 'sale-traking', component: SaleTrackingComponent, data: { blank: true } },
  { path: 'consegna-monitoraggio/:id', component: DeliveryMonitoringComponent, data: { blank: true } },
  { path: 'sales/payments', component: CustomSalesPaymentsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] }  },

  { path: 'approve/timings/:id', component: ApproveTimingsAdminComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] }  },

  { path: 'expert/payments', component: ValetPaymentsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation'] } },
  { path: 'expert/payments/storico', component: ValetPaymentsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'partner'] }  },

  { path: 'expert/receipts', component: ValetPaymentReceiptsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: true, groups: ['admin', 'operation', 'expert'] } },
  { path: 'expert/receipts/storico', component: ValetPaymentReceiptsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation', 'expert'] } },

  { path: 'expert/contracts', component: ValetContractsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { active: false, groups: ['admin', 'operation'] } },

  {
    path: 'activities',
    component: ActvitiesComponent,
    canActivate: [CanActivateLogIn, ActivityRedirection, GroupRestricted, ViewRestricted],
    data: { groups: ['admin', 'operation', 'expert'] },
    children: [
      {
        path: 'own',
        children: [
          {
            path: '',
            component: ValetActivitiesComponent,
            data: { groups: ['expert'], active: true },
          },
          {
            path: 'storico',
            component: ValetActivitiesComponent,
            data: { groups: ['expert'], active: false },
          },
        ],
      },
      {
        path: 'other/valet',
        children: [
          {
            path: '',
            component: AdminValetActivityComponent,
            data: { groups: ['admin', 'operation', 'expert'], active: true },
          },
          {
            path: 'storico',
            component: AdminValetActivityComponent,
            data: { groups: ['admin', 'operation', 'expert'], active: false },
          },
        ],
      },
    ],
  },
  { path: 'optimized-route', component: ShowMapDirectionComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] }  },

  /* New Sales Integration */

  { path: 'customers', component: CustomersComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },
  { path: 'customer/nuovo', component: CustomerFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },
  { path: 'customer/edit/:id', component: CustomerFormDecoratorComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },

  { path: 'provinces/cities', component: ProvinceCitiesComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'provinces/cities/edit/:id', component: ProvinceCitiesFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },

  {
    path: 'finanza',
    component: FinanceComponent,
    canActivate: [CanActivateLogIn, SuperAdminGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'corrispettivi', // Redirect base path to corrispettivi
      },
      {
        path: 'margini',
        component: FinanceMarginComponent,
      },
      {
        path: 'corrispettivi',
        children: [
          {
            path: '',
            component: FinanceFeesComponent,
          },
        ],
      },
    ],
  },

  { path: 'consegne/consegnato/:token', component: DeliveredDeliveryComponent },
  { path: 'notifications', component: NotificationsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner', 'expert'] }  },
  
  {
    path: 'transzioni',
    component: TransactionsTabsComponent,
    canActivate: [CanActivateLogIn, GroupRestricted],
    data: { groups: ['admin', 'operation', 'expert'] },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'valet',
      },
      {
        path: 'valet',
        children: [
          {
            path: '',
            component: TransactionsComponent,
          },
        ],
      },
    ],
  },

  { path: 'qontoCallback', component: QontoCallbackComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin'] }  },
  { path: 'collections', component: ShopCollectionComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'collections/nuovo', component: ShopCollectionFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'collections/edit/:id', component: ShopCollectionFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },

  { path: 'partner/cards', component: PartnerStripeCardComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },
  { path: 'partner/cards/nuovo', component: PartnerStripeCardFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },
  { path: 'partner/cards/edit/:id', component: PartnerStripeCardFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'stripe/customer/:id', component: CustomerCardInfoComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation', 'partner'] }  },

  { path: 'bundle/product', component: BundleProductComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'bundle/product/nuovo', component: BundleProductFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },
  { path: 'bundle/product/edit/:id', component: BundleProductFormComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] }  },

  { path: "partner-activity-reminder", component: PartnerActivityReminderSettingsComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  { path: 'product-import', component: ProductImportComponent, canActivate: [CanActivateLogIn, GroupRestricted], data: { groups: ['admin', 'operation'] } },
  
  /*test routes */
  { path: 'test', component: TestComponent  },
  /*test routes */
  { path: '403', component: AccessDeniedComponent, data: { blank: true } },
  { path: '404', component: NotFoundComponent, data: { blank: true } },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
